import React, {Component} from 'react';
import axios from 'axios';
import {FaDatabase} from "react-icons/fa";
import { connect } from 'react-redux';
import {Alert} from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import { Card, CardBody, Row } from 'reactstrap';
import BreadcrumbCustomer from "../../Layout/user/BreadcrumbCustomer";

class OrderUpgradeHostingComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            isLoading: true,
            vps: {},
            error: false,
            messageError: '',
            errorForm: false,
            messageErrorForm: '',
            isNotification: '',
            textNotification: '',
            isModal: false,
            isSpinner: false,
            listProductUpgrade: {},
            configBilling: {
                'monthly' : '1 Tháng',
                'twomonthly' : '2 Tháng',
                'quarterly' : '3 Tháng',
                'semi_annually' : '6 Tháng',
                'annually' : '1 Năm',
                'biennially' : '2 Năm',
                'triennially' : '3 Năm',
                'one_time_pay' : 'Vĩnh viễn',
                'free' : 'Miễn phí',
            },
            btnSubmit: true,
            sub_total: 0,
            productUpgradeId: 0,
            productUpgrade: []
        }
    }

    componentDidMount() {
        document.querySelector('.cr-sidebar').classList.add('cr-sidebar--open');
        window.scrollTo(0, 0);
        this.getConfigUpgradeHosting(this.props.hostingId);
        // this.loadPricing();

        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
        })
        if (this.props.isNotification) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
    }

    getConfigUpgradeHosting = (hostingId) => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        axios.get( process.env.REACT_APP_API_URL + '/api/order/getConfigUpgradeHosting/' + hostingId,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if (ref.data.error === 0) {
                    this.setState({
                        loadPage: false,
                        isLoading: false,
                        listProductUpgrade: ref.data.listProductUpgrade,
                        hosting: ref.data.hosting,
                        btnSubmit: false,
                    })
                } else {
                    if (ref.data.error >= 9000) {
                        this.props.logOut();
                    }
                    else if (ref.data.error >= 8000) {
                        this.redirectHome(ref.data.message);
                    }
                    else if (ref.data.error >= 7000) {
                        this.redirectBack(ref.data.message);
                    }
                    else {
                        this.setState({
                            loadPage: false,
                            isLoading: false,
                            error: true,
                            messageError: ref.data.message,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu sản phẩm thất bại',
                })
            })
    }

    addCommas = (nStr) => {
        nStr += '';
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            // eslint-disable-next-line no-useless-concat
            x1 = x1.replace(rgx, '$1' + '.' + '$2');
        }
        return x1 + x2;
    }

    loadConfig  = () => {
        if ( Object.keys(this.state.hosting).length ) {
            return (
                <>
                    Hosting: { this.state.hosting.domain } <br/>
                    Sản phẩm: { this.state.hosting.text_product_name } <br/>
                    Số lượng Domain: { this.state.hosting.qtt_domain } Domain<br/>
                    Số lượng Database: { this.state.hosting.qtt_database } Database<br/>
                    Thời gian thuê: { this.state.hosting.text_billing_cycle } <br/>
                    Ngày kết thúc: { this.state.hosting.text_next_due_date } <br/>
                </>
            )
        }
    }

    loadUpgrade = () => {
        if ( !this.state.listProductUpgrade.error ) {
            // console.log(this.state.listAddon.addonCpu)
            return (
                <div className="form-group">
                    <div className="mt-4 mb-2">
                        <span className="font-weight-bold">
                            Gói nâng cấp khả dụng:
                        </span>
                    </div>
                    {
                        this.state.listProductUpgrade.productUpdate.map( (productUpdate, key) => (
                            <div className="product-upgrade rounded" key={key}>
                                <div className="row">
                                    <div className="col-8">
                                        <strong>Cloud Hosting cPanel - { productUpdate.name }</strong> <br />
                                            Dung lượng: { productUpdate.product_detail.storage } MB <br/>
                                            <b>Unlimited Data Transfer</b> <br/>
                                            Số lượng Domain: { productUpdate.product_detail.domain } domain <br/>
                                            Sub Domain: { productUpdate.product_detail.sub_domain } <br/>
                                            Alias Domain: { productUpdate.product_detail.alias_domain } <br/>
                                            Database: { productUpdate.product_detail.database } database <br/>
                                            FTP: { productUpdate.product_detail.ftp } tài khoản <br />
                                    </div>
                                    <div className="col-4">
                                        <strong> Chi phí: { this.addCommas( productUpdate.amount ) } ₫ / 1 Năm</strong>
                                        <br />
                                        <button type="button" className="btn btn-block btn-primary btn-choosse-product"
                                                onClick={ () => this.btnUpgrade(key) }
                                        >
                                            Chọn sản phẩm / dịch vụ
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            )
        }
    }

    btnUpgrade = (key) => {
        let productUpgrade = this.state.listProductUpgrade.productUpdate[key];
        this.setState({
            productUpgradeId: productUpgrade.id,
            sub_total: productUpgrade.amount,
            productUpgrade: productUpgrade
        })
    }

    loadPricing = () => {
        if ( !this.state.listProductUpgrade.error ) {
            // console.log(this.state.listAddon.addonCpu)
            let sub_total = 0;
            this.setState({
                sub_total: sub_total
            })
        }
    }

    redirect = (orderId) => {
        this.props.updateSuccessNotiUser({
            success: true,
            message: 'Tạo đơn hàng nâng cấp Hosting thành công'
        });
        this.props.shouldRedirect(orderId);
    }

    redirectHome = (message) => {
        this.props.updateErrorNotiUser({
            error: true,
            message: message
        });
        this.props.redirectHome();
    }

    redirectBack = (message) => {
        this.props.updateErrorNotiUser({
            error: true,
            message: message
        });
        this.props.redirectBack();
    }

    submit = () => {
        this.setState({
            btnSubmit: true,
        })
        if ( this.validate() ) {
            this.setState({
                loadPage: true,
            })
            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            let form = {
                hostingId: this.props.hostingId,
                productUpgradeId: this.state.productUpgradeId,
            };
            // console.log(form)
            axios.post( process.env.REACT_APP_API_URL + '/api/order/createOrderUpgradeHosting', form,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    if (ref.data.error === 0) {
                        this.redirect( ref.data.orderId );
                    } else {
                        if (ref.data.error > 9000) {
                            this.props.logOut();
                        }
                        else if ( ref.data.error >= 8000 ) {
                            this.redirectHome( ref.data.message );
                        }
                        else {
                            this.setState({
                                btnSubmit: false,
                                errorForm: true,
                                messageErrorForm: ref.data.message,
                                loadPage: false,
                                isLoading: false,
                            })
                        }
                    }
                    // console.log(this.state.perPage);
                })
                .catch( (error) => {
                    console.log(error);
                    this.setState({
                        btnSubmit: false,
                        loadPage: false,
                        isLoading: false,
                        errorForm: true,
                        messageErrorForm: 'Tạo đơn đặt hàng thất bại',
                    })
                })
        }
    }

    validate = () => {
        if ( !this.state.productUpgradeId ) {
            this.setState({
                btnSubmit: false,
                errorForm: true,
                messageErrorForm: 'Gói nâng cấp không được để trống',
            })
            return false;
        }
        return true;
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <BreadcrumbCustomer title={"Đặt hàng nâng cấp Hosting"} page={"Cloud Hosting"}
                                                icon={<FaDatabase className="breadcrumb-icon"/>}/>
                            {
                                this.state.error ? (
                                    <Alert color="danger">
                                        <div className='text-center'>
                                            {this.state.messageError}
                                        </div>
                                    </Alert>
                                ) : (
                                    <Card>
                                        <CardBody>
                                            <Row>
                                                {
                                                    this.state.errorForm ? (
                                                        <div className="col-12 col-lg-12">
                                                            <Alert color="danger">
                                                                { this.state.messageErrorForm }
                                                            </Alert>
                                                        </div>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                                <div className="col-12 col-lg-7">
                                                    <div className="product-info rounded">
                                                        <p className="product-title">
                                                            Hosting { this.state.hosting.domain }
                                                        </p>
                                                        <p className="config-product">
                                                            {
                                                                this.loadConfig()
                                                            }
                                                        </p>
                                                    </div>
                                                    {
                                                        this.loadUpgrade()
                                                    }
                                                </div>
                                                <div className="col-12 col-lg-5">
                                                    <div className="detail-order">
                                                        <div className="title-detail-order">
                                                            Tóm tắt đơn hàng
                                                        </div>
                                                        <div className="order-summary">
                                                            <div className="addon-item-cpu">
                                                                {
                                                                    this.state.productUpgradeId ? (
                                                                        <div className="item">
                                                                            <div className="row">
                                                                                <div className="col col-md-6 item_billing">
                                                                                    { this.state.productUpgrade.name }
                                                                                </div>
                                                                                <div className="col col-md-6 item_pricing text-right">
                                                                                    { this.addCommas( this.state.sub_total ) } ₫
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <></>
                                                                    )
                                                                }
                                                            </div>
                                                            <div className="order-summary-total">
                                                                <div className="row">
                                                                    <div className="col-md-4">Tổng cộng</div>
                                                                    <div className="col-md-8 text-right">{ this.addCommas( this.state.sub_total ) } ₫</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="button_submit text-center">
                                                            <button type="button" className="btn btn-block btn-primary"
                                                                    disabled={ this.state.btnSubmit }
                                                                    onClick={ () => this.submit() }
                                                            >
                                                                Đặt hàng
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                )
                            }
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        user: state.user.user,
        credit: state.user.credit,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
        errorNotificationUser: state.notificationUser.errorNotificationUser,
        messageErrorNotificationUser: state.notificationUser.messageErrorNotificationUser,
        successNotificationUser: state.notificationUser.successNotificationUser,
        messageSuccessNotificationUser: state.notificationUser.messageSuccessNotificationUser,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'CustomerHostingUpgrade' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
        updateSuccessNotiUser: (item) => {
            dispatch(({ type : 'updateSuccessNotiUser', item }))
        },
        updateErrorNotiUser: (item) => {
            dispatch(({ type : 'updateErrorNotiUser', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(OrderUpgradeHostingComponent);